<template>
<div>
  <!-- <top-bar></top-bar> -->
  <top-slider></top-slider>
  <top-menu></top-menu>
  <div class="page_content_box">
      <div class="wrap">
        <div class="location">
            <bread-crumb></bread-crumb>
        </div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="login_form">
            <el-form-item label="手机号" prop="mobile">
                <el-input v-model="ruleForm.mobile" maxlength="11"></el-input>
            </el-form-item>
            <el-form-item label="验证码" class="verCode_item" prop="code">
                <el-input v-model="ruleForm.code" placeholder=""></el-input>
                <!-- 因为获取不到验证码，所以暂时注释，后期有可能恢复 -->
                
                <div class="getCode" v-show="!dCount.showCountDown" @click="getCode">获取验证码</div>
                <div class="countDown" v-show="dCount.showCountDown">{{dCount.count}}秒后重新获取</div>
                
                 <!-- <div class="getCode" @click="showWarning">获取验证码</div> -->
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submitForm('ruleForm')" class="btn_submit">确 定</el-button>
            </el-form-item>
        </el-form>

      </div>
  </div>
  <Footer></Footer>
</div>
</template>

<script>
import TopMenu from '@/components/TopMenu.vue'
// import TopBar from '@/components/TopBar.vue'
import Footer from '@/components/Footer.vue'
import TopSlider from '@/components/TopSlider.vue'
import BreadCrumb from '@/components/BreadCrumb.vue'
import { getSmsCode,smsLogin,getUserInfo } from '@/service/api.js'
import { vPhone } from '@/utils/Validate.js'
import {encrypt} from "../../utils/jsencrypt";

export default {
    // components: { TopMenu,TopBar,Footer,TopSlider,BreadCrumb },
    components: { TopMenu,Footer,TopSlider,BreadCrumb },
    data() {
        return {
            dCount:{
                showCountDown:false,
                count:'',
                timer:null,
            },
            ruleForm:{
                mobile:'',
                code:''
            },
            rules:{
                mobile: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { validator: vPhone, required: true, trigger: 'blur' }
                ],
                code: [
                    { required: true, message: '请输入验证码', trigger: 'blur' }
                ],
            }
        }
    },
    methods: {
        // 提示系统正在升级中
        showWarning(){
            this.$message.error('请输入验证码')
        },
        // 获取验证码
        getCode(){
            this.$refs.ruleForm.validateField('mobile',(error) => {
                if (error) {
                    console.log('mobile',error);
                }else{
                    const TIME_COUNT = 60;
                    if (!this.dCount.timer) {
                        this.dCount.count = TIME_COUNT;
                        this.dCount.showCountDown = true;
                        this.dCount.timer = setInterval(() => {
                            if (this.dCount.count > 0 && this.dCount.count <= TIME_COUNT) {
                                this.dCount.count--;
                            } else {
                                this.dCount.showCountDown = false;
                                clearInterval(this.dCount.timer);
                                this.dCount.timer = null;
                            }
                        }, 1000)
                    }
                    getSmsCode({mobile:encrypt(''+this.ruleForm.mobile)}).then(data=>{
                        if (data.code !==0) {
                            this.$message.error(data.msg)
                        }
                    })
                }
            })
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    smsLogin(this.ruleForm).then(data=>{
                        // console.log(data);
                        if (data.code !==0) {
                            this.$message.error(data.msg)
                        }else {
                            if (data.token) {
                                localStorage.setItem('token',data.token)
                                getUserInfo().then(data=>{
                                    console.log(data);
                                    if (data.code !== 0 ) {
                                        this.$message.error(data.msg)
                                    }else{
                                        this.$store.commit('setUserInfo',data.data)
                                        const fromUrlName = localStorage.getItem('fromUrlName')
                                        if (fromUrlName!=='null') {
                                            this.$router.push({name:fromUrlName})
                                        }else{
                                            this.$router.push({name:'PersonalInfo'})
                                        }
                                    }

                                })
                            }

                        }

                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
    },
}
</script>

<style lang="less" scoped>
.page_content_box {
    .wrap {
        padding: 0 10px 35px;
    }
    .login_form {
        width: 500px;
        margin: 20px auto;

    }
    .getCode {
        width: 110px;
        height: 40px;
        text-align: center;
        border: solid 1px #DDD;
        background-color: #FFF;
        color: #333;
        border-radius: 5px;
        cursor: pointer;
        display: inline-block;
        vertical-align: top;
        margin-left: 20px;
    }
    .countDown {
        width: 110px;
        height: 40px;
        text-align: center;
        border: solid 1px #DDD;
        background-color: rgb(218, 218, 218);
        color: #333;
        border-radius: 5px;
        display: inline-block;
        vertical-align: top;
        font-size: 12px;
        margin-left: 20px;
    }
    .verCode_item {
        .el-input {
            width: 250px;
        }
    }
    .btn_submit {
        background-color: #18388b;
        border: none;
    }
}
</style>

